<template>
    <div>
        <div class="designeroption" id="frame_style" data-designer-component-id="side_panels">
            <h3>Configure Your Frame</h3>
            <div class="activatepanels">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the switches.</p>
                    <p>Once you select a panel further options will be available.</p>
                </div>

                <div :class="['options']">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="target.checkedPanels"/>
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="target.checkedPanels"/>
                        <img :src="'/images/activatepanelsimg.jpg'" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="target.checkedPanels"/>
                    </div>
                </div>

                <div class="switches">
                    <div class="switchbox">
                        <p>Top</p>
                        <input type="checkbox" value="top" v-model="target.checkedPanels"/>
                        <span class="status" v-text="sideIsChecked('top') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox">
                        <p>Left</p>
                        <input type="checkbox" value="left" v-model="target.checkedPanels"/>
                        <span class="status" v-text="sideIsChecked('left') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox">
                        <p>Right</p>
                        <input type="checkbox" value="right" v-model="target.checkedPanels"/>
                        <span class="status" v-text="sideIsChecked('right') ? 'On' : 'Off'"></span>
                    </div>
                </div>

            </div>
        </div>

        <div class="designeroption">
            <doorco-designer-question-frame-style :fabricator="fabricator" :is-firedoor="isFiredoor" :frame-material="1" :title="title" v-model:target="target.frame_id" :checked-panels="target.checkedPanels">

            </doorco-designer-question-frame-style>
        </div>
    </div>
</template>


<style>
    .side-panels .panel_check { opacity:1!important }
    .side-panels span { margin-left:30px; font-weight:normal; }
    .side-panels label:hover { cursor:pointer; }
</style>


<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameStyle from "../DesignerQuestionSelectFrameStyle.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameStyle
        ],
        props: {
            isFiredoor: {
                required: true
            }
        }
    }
</script>
